<template>
  <!-- Main Content -->
  <div class="body_area after_bg sm">
    <div class="block-header">
      <div class="container">
        <div class="row clearfix">
          <div class="col-lg-6 col-md-12">
            <h1 class="mb-1 mt-1">
              <div class="body profile-header">
                {{ $route.params.appId }}
                <span v-if="$store.state.devStore.title != null">
                  : {{ $store.state.devStore.title }}</span
                >
              </div>
            </h1>
          </div>
        </div>
        <div class="bh_divider"></div>
        <div class="row clearfix">
          <div class="col-12">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <div class="nav-link checkLiTop">
                  <font-awesome-icon :icon="faCube" /> :</div>
              </li>
              <li class="nav-item " @click="checkingMenus(0)" >
                <div class="nav-link checkLiTop" :class="{ active: homeMenu }">홈</div>
              </li>
              <li
                class="nav-item"
                @mouseenter="enterDropMenuAuth"
                @mouseleave="outDropMenuAuth"
              >
                <div
                  class="nav-link checkLiTop"
                  :class="{ active: authMenu }"
                  @click="checkingMenus(1)"
                >
                  인증
                </div>
                <ul class="devSubMenu ml-menu" v-if="smallMenuAut">
                  <li v-for="(auth, index) in authList" v-bind:key="index">
                    <a
                      href="javascript:void(0)"
                      class="waves-effect waves-block"
                      @click="smallMenuAuth(index)"
                      ><font-awesome-icon :icon="faPencilAlt" /> {{ auth.apiName }} ( {{auth.versionCode}} )</a
                    >
                  </li>
                </ul>
              </li>

              <li
                class="nav-item"
                @mouseenter="enterDropMenu"
                @mouseleave="outDropMenu"
              >
                <div
                  class="nav-link checkLiTop thisIsMenu"
                  :class="{ active: trigMenu }"
                  @click="checkingMenus(2)"
                >
                  트리거
                </div>
                <ul class="devSubMenu ml-menu" v-if="smallMenuTrigger">
                  <li v-for="(trig, index) in trigList" v-bind:key="index">
                    <a
                      href="javascript:void(0)"
                      class="waves-effect waves-block"
                      @click="smallMenuTrig(index)"
                      ><font-awesome-icon :icon="faPencilAlt" /> {{ trig.apiName }} ( {{trig.versionCode}} )</a
                    >
                  </li>
                </ul>
              </li>
              <li
                class="nav-item"
                @mouseenter="enterDropMenuAct"
                @mouseleave="outDropMenuAct"
              >
                <div
                  class="nav-link checkLiTop"
                  :class="{ active: actMenu }"
                  @click="checkingMenus(3)"
                >
                  액션
                </div>
                <ul class="devSubMenu ml-menu" v-if="smallMenuAction">
                  <li v-for="(act, index) in actList" v-bind:key="index">
                    <a
                      href="javascript:void(0)"
                      class="waves-effect waves-block"
                      @click="smallMenuAct(index)"
                      ><font-awesome-icon :icon="faPencilAlt" /> {{ act.apiName }} ( {{act.versionCode}} )</a
                    >
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <div class="nav-link checkLiTop">
                  <font-awesome-icon :icon="faCube" /> :</div>
              </li>
              <li class="nav-item">
                <div
                  class="nav-link checkLiTop"
                  :class="{ active: verMenu }"
                  @click="checkingMenus(4)"
                >
                  버전
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row clearfix">
        <div class="col-lg-12">
          <div class="tab-content">
            <!-- <dev-menu /> -->

            <div class="tab-pane active" style="min-height: 800px">
              <div class="clearfix row-deck">
                <router-view
                  v-bind:menuType="heading"
                  v-on:childEvent="changeStatus"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer-view />
    </div>
  </div>
</template>

<script>
import FooterView from "@/components/common/FooterView.vue";
// import DevMenu from '@/components/dev/DevMenu.vue'
// import DevMainDetailFirst from '@/components/dev/DevMainDetailFirst.vue'
// import Urls from '@/common/urls'
// import Apiroot from '@/common/apiroot'
import eventbus from "@/store/modules/devEventBus";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { faSun } from '@fortawesome/free-regular-svg-icons'
import {faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import {faCube} from "@fortawesome/free-solid-svg-icons";
// import {faStar} from "@fortawesome/free-regular-svg-icons";

export default {
  components: {
    FontAwesomeIcon:FontAwesomeIcon,
    FooterView: FooterView,
    // "DevMenu": DevMenu,
    // "DevMainDetailFirst": DevMainDetailFirst,
  },
  methods: {
    changeStatus() {
      console.log("here");
    },
    checkingMenus(num) {
      this.homeMenu = false;
      this.authMenu = false;
      this.trigMenu = false;
      this.actMenu = false;
      this.verMenu = false;

      if (num == 0) {
        this.$store.state.devStore.title = null;
        this.homeMenu = true;
        // this.heading = "Home";
        // this.$store.state.devStore.urlType = "home";
        console.log(this.$route.params.appId);

        this.$router.push({
          name: "DevelopAppPage",
          params: { appId: this.$route.params.appId },
        });

        // this.$router
        //   .push("/developer/app/" + this.$route.params.appId + "/home")
        //   .catch(() => {});

        // location.href = "/developer/app/main/" + this.choseApp
      } else if (num == 1) {
        this.authMenu = true;
        this.$store.state.devStore.urlType = "auths";
        // this.$store.state.devStore.title = 'auths'

        this.$router.push({
          name: "DevelopAppAuthPage",
          params: { appId: this.$route.params.appId },
        });

        // this.$router
        //   .push(
        //     "/developer/app/" +
        //       this.$route.params.appId +
        //       "/authentication/main"
        //   )
        //   .catch(() => {});
      } else if (num == 2) {
        this.trigMenu = true;
        this.$store.state.devStore.urlType = "triggers";

        this.$router.push({
          name: "DevelopAppTriggerPage",
          params: { appId: this.$route.params.appId },
        });

        // this.$router
        //   .push("/developer/app/" + this.$route.params.appId + "/trigger/main")
        //   .catch(() => {});
      } else if (num == 3) {
        this.actMenu = true;
        this.$store.state.devStore.urlType = "actions";

        this.$router.push({
          name: "DevActMain",
          params: { appId: this.$route.params.appId },
        });

        // this.$router
        //   .push("/developer/app/" + this.$route.params.appId + "/action/main")
        //   .catch(() => {});
      } else if (num == 4) {
        this.verMenu = true;
        this.heading = "Version";
        this.$store.state.devStore.urlType = "version";

        this.$router.push({
          name: "DevVersion",
          params: { appId: this.$route.params.appId },
        });

        // this.$router
        //   .push("/developer/app/" + this.$route.params.appId + "/version/main")
        //   .catch(() => {});
      }
    },
    smallMenuAuth(value) {
      console.log(value);
      console.log(this.authList[value]);

      this.$store.state.devStore.title = this.authList[value].apiType;
      this.$store.state.devStore.apiCode = this.authList[value].apiCode;

      // alert(this.$store.state.devStore.apiCode)

      this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{

      this.$store
        .dispatch("apiDetail", {result:res})
        .then(() => {
          console.log(this.$store.state.devStore.apiData);
          // console.log(this.$store.state.devStore.formsData)
          // console.log(this.$store.state.devStore.configureData)

          this.$router.push({
            name: "DevAuthSetting",
            params: {appId: this.$route.params.appId},
          });
        })
        .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));
        })
      .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));
    },
    smallMenuTrig(index) {
      var name = this.trigList[index].apiName;
      this.$store.state.devStore.title = name;
      this.$store.state.devStore.apiCode = this.trigList[index].apiCode;

      eventbus.$emit("updateTrigger");

      this.$router.push({
        name: "DevTrigSetting",
        params: { appId: this.$route.params.appId, trigName: name },
      });
    },
    smallMenuAct(index) {
      var name = this.actList[index].apiName;
      this.$store.state.devStore.title = name;
      this.$store.state.devStore.apiCode = this.actList[index].apiCode;

      eventbus.$emit("updateAuth");

      this.$router.push({
        name: "DevActSetting",
        params: { appId: this.$route.params.appId, actName: name },
      });
      // eventbus.$emit("apiCode", this.apiAuth[value].apiCode);
      // this.$store.state.devStore.apiCode =
      //   this.$store.state.devStore.apiAct[value].apiCode;
      // this.$store.state.devStore.title =
      //   this.$store.state.devStore.apiAct[value].apiName;
      // this.$router.push({ name: "DevActionSettings" });
    },

    enterDropMenuAuth() {
      this.smallMenuAut = true;
    },
    outDropMenuAuth() {
      this.smallMenuAut = false;
    },
    enterDropMenu() {
      this.smallMenuTrigger = true;
    },
    outDropMenu() {
      this.smallMenuTrigger = false;
    },
    enterDropMenuAct() {
      this.smallMenuAction = true;
    },
    outDropMenuAct() {
      this.smallMenuAction = false;
    },
  },

  data() {
    return {
      heading: "Home",

      homeMenu: true,
      authMenu: false,
      trigMenu: false,
      actMenu: false,
      verMenu: false,

      smallMenuAut: false,
      smallMenuTrigger: false,
      smallMenuAction: false,

      choseApp: "",

      authList: [],
      trigList: [],
      actList: [],

      modalClick: false,

      faPencilAlt,
      faCube,
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.name);

      this.homeMenu = false;
      this.authMenu = false;
      this.trigMenu = false;
      this.actMenu = false;
      this.verMenu = false;

      if (to.name.includes("App")) {
        // console.log(from.name)
        console.log(to.name);
        this.homeMenu = !this.homeMenu;
        this.heading = "Home";
      } else if (to.name.includes("Auth")) {
        // console.log(from.name)
        console.log(to.name);
        this.authMenu = !this.authMenu;
        this.heading = "Authentication";
      } else if (to.name.includes("Trig")) {
        this.trigMenu = !this.trigMenu;
        this.heading = "Trigger";
      } else if (to.name.includes("Act")) {
        this.actMenu = !this.actMenu;
        this.heading = "Actions";
      } else if (to.name.includes("Version")) {
        this.verMenu = !this.verMenu;
        this.heading = "Actions";
      } else if (to.name.includes("Integration")) {
        this.homeMenu = !this.homeMenu;
        this.heading = "Home";
      }




      if (from.name.includes("Setting")) {
        // this.$store.dispatch("apiSetting").then(() => {
          // console.log("라우터 번경 :", this.$store.state.devStore.apiTrig);
          this.authList = this.$store.getters.getAuthApiData;
          this.trigList = this.$store.getters.getTrigApiData;
          this.actList = this.$store.getters.getActApiData;
        // });
      }
    },
    // checkValues(){
    //     console.log('main detail : ', this.$store.state.devStore.authList)
    //     this.authList = this.$store.state.devStore.authList
    // }
  },
  computed: {
    // checkValues(){return this.$store.state.devStore.apiAuth}
  },
  mounted() {},
  created() {
    // console.log('해당 url ')
    // console.log(window.location.pathname)
    // console.log(this.$route.params.appId)

    this.choseApp == this.$route.params.appId;
    var url = window.location.pathname;

    console.log("url :", url);

    // if (url.includes("trigger")) {
    //   this.checkingMenus(2);
    // } else if (url.includes("action")) {
    //   this.checkingMenus(3);
    // } else if (url.includes("authentication")){
    //   this.checkingMenus(1);
    // } else {
    this.checkingMenus(0);

    eventbus.$on("menuReset", () => {
      console.log("menu reset ~~~~ ");



      this.$store
        .dispatch("apiSetting")
        .then((res) => {
          console.log("결과값:", res);

          this.authList = this.$store.state.devStore.apiAuth;
          this.trigList = this.$store.state.devStore.apiTrig;
          this.actList = this.$store.state.devStore.apiAct;

          eventbus.$emit("menuSetted");
        })
        .catch(() => {
          alert("오류가 발생했습니다. dev main detail")
          // location.href = "/"
        });
    });

    // }

    this.$store
      .dispatch("apiSetting")
      .then((res) => {
        console.log("결과값:", res);

        this.authList = this.$store.state.devStore.apiAuth;
        this.trigList = this.$store.state.devStore.apiTrig;
        this.actList = this.$store.state.devStore.apiAct;
      })
      .catch(() => {
        alert("오류가 발생했습니다. dev main detail")
        // location.href = "/"
      });
  },
};
</script>

<style>
  .checkLiTop:after {
    content : none !important;
  }
</style>
